"use strict";
import { createAdaptiveRefetchContext } from "graphql/data/apollo/AdaptiveRefetch";
const {
  Provider: AdaptiveTokenBalancesProvider,
  useQuery: useTokenBalancesQuery,
  PrefetchWrapper: PrefetchBalancesWrapper
} = createAdaptiveRefetchContext();
export { AdaptiveTokenBalancesProvider, PrefetchBalancesWrapper, useTokenBalancesQuery };
